<template>
  <!-- // 报表钻取明细 -->
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 10px">
      <div style="margin-bottom: 10px">
        <el-button type="primary" size="small" @click="exportList()"
          >导出</el-button
        >
      </div>
      <div>
        <div>
          <el-table
            v-loading="listLoading"
            :data="zxlc.wdgList.list"
            fit
            :header-cell-style="tableHeaderColor"
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
            :max-height="height"
          >
            <el-table-column
              label="项目名称"
              prop="xmmc"
              min-width="150px"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <el-table-column
              label="合同状态"
              prop="htzt"
              min-width="100px"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <el-table-column
              label="合同起止日期"
              prop="htqzsj"
              min-width="170px"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <el-table-column
              label="区域总监"
              prop="qyzj"
              min-width="100px"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <el-table-column
              label="提交人"
              prop="tjr"
              min-width="100px"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            、
            <el-table-column
              label="提交时间"
              prop="tjsj"
              min-width="100px"
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
          <pagination
            v-show="zxlc.wdgList.total > 0"
            :total="zxlc.wdgList.total"
            :page.sync="params.page"
            :limit.sync="params.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { ybsbgwdgExport } from "@/api/zxlc";
export default {
  // 列表分页
  name: "xmxyList",
  components: { Treeselect, Pagination },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
  },
  props: ["mxParams", "params"],
  data: () => {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      height: 800,
      listLoading: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
  },
  methods: {
    getList() {
      this.$store.dispatch("zxlc/fetchWdgListAction", {
        ...this.params,
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    exportList() {
      ybsbgwdgExport({ ...this.params }).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath; // 组装a标签
          const elink = document.createElement("a"); // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  padding-top: 0;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

